/**
 * 
 * Application wide factory types. 
 * Do not abuse this scope.
 * 
 */
import { reducer as ShellReducers } from 'app/shell/reducers';
import { reducer as CaseReducers } from 'app/area/case/reducers';
import { reducer as ResponseCachingReducers } from 'app/area/shared/response-caching/reducers';
import { reducer as CodeSelectorReducer} from 'app/area/code-selector/reducers';
import { reducer as RemoteDataReducers } from 'app/infrastructure/remote-data/reducers';
import { ApplicationState } from 'app/types-store';
import { AuthState } from 'app/types-shared';
import { STATE } from 'app/constants';

/**
 * The difference in minutes (as seen from UTC) between UTC and Client's time zone
 */
const clientDateOffset = -1 * new Date().getTimezoneOffset();

/**
 * The initial state of the complete application at root url
 */
export const INITIAL_APP_STATE: ApplicationState = {
  app: {
    settings: {
      baseUrl: '',
      utcOffset: clientDateOffset,
      fallbackLocale: 'en'
    },
    authState: AuthState.Anonymous,
    texts: {} as any,
    fetching: false,
    errors: [],
    messages: []
  },
  userProfileArea: {}
};

/** 
 * Whenever an action is dispatched, Redux will update each top-level application state property using
 * the reducer with the matching name. It's important that the names match exactly, and that the reducer
 * acts on the corresponding ApplicationState property type
 */
export const reducers = {
  [STATE.app]: ShellReducers,
  [STATE.remoteData]: RemoteDataReducers,
  // There are currently no active startup reducers in startup, but text collection gets loaded by convention
  [STATE.startupAnonymousArea]: (state: any = {}) => state,
  [STATE.case]: CaseReducers,
  [STATE.responseCaching]: ResponseCachingReducers,
  [STATE.codeSelector]: CodeSelectorReducer
};
